// src/components/shared/ParishSelect.jsx
// A choice among an area's parishes (own-parish addenda 1–2, Roadmap #73): "Publishing to" in the
// article and event forms, and "Your own parish" in My Locations. Options come from
// getAreaParishes() (src/data/directoryService.js). With one option — or none, while names load —
// it shows the current parish as a read-only line instead of a select.
//
// Props: label, hint (optional line under it), options [{id, name}], value (a parish id),
// onChange(id: number), readOnlyName (shown when there is nothing to choose), disabled.
import React from 'react';

const ParishSelect = ({ label, hint, options = [], value, onChange, readOnlyName, disabled = false }) => {
  const current = options.find(o => o.id === Number(value));
  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">{label}</label>
      {options.length > 1 && !disabled ? (
        <select
          value={value ?? ''}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[var(--theme-primary)]"
        >
          {options.map((o) => (
            <option key={o.id} value={o.id}>{o.name}</option>
          ))}
        </select>
      ) : (
        <div className="w-full px-4 py-3 rounded-lg border border-gray-300 bg-gray-50 text-gray-700">
          {current?.name || readOnlyName}
        </div>
      )}
      {hint && <p className="text-gray-500 text-sm mt-1">{hint}</p>}
    </div>
  );
};

export default ParishSelect;
